import { create } from 'zustand';

const useVideoStore = create((set) => ({
  videoLoaded: false,
  setVideoLoaded: () => set({ videoLoaded: true }),
  resetVideoLoaded: () => set({ videoLoaded: false }),
}));

// upload

export default useVideoStore;